exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".layout_wrapper--KgxX-_Nu9VpwFPcEU4TqQ{margin-top:30px;height:100%}.layout_wrapper--KgxX-_Nu9VpwFPcEU4TqQ .sider--1xFhpj_PYoAsBddn4nEAuB{margin-right:20px;height:300px}.data_wrapper--2aP-S1bgKLpZXS1kPKPYYP .header--9gRrBKt5FtN4oYBM-cc8P{margin-bottom:20px}.data_wrapper--2aP-S1bgKLpZXS1kPKPYYP .header--9gRrBKt5FtN4oYBM-cc8P .search_btn--kCuC388Mx_Hg-z0gldOW3{margin-left:10px}.table_footer--2eslvltnNXFktxqTBd6I5D{height:50px;padding:10px;margin-top:30px}.table_footer--2eslvltnNXFktxqTBd6I5D .total_num--2Mgc9O_EhblXhWlLeHuhf_{font-size:20px}.pager--JZFtfaCzZuy0BugCbPw3o{margin-top:10px}.confirm--2Ps6XqG-esm1c5DkGXYKjc{text-align:center;color:red;border:1px solid red}\n", ""]);

// Exports
exports.locals = {
	"layout_wrapper": "layout_wrapper--KgxX-_Nu9VpwFPcEU4TqQ",
	"sider": "sider--1xFhpj_PYoAsBddn4nEAuB",
	"data_wrapper": "data_wrapper--2aP-S1bgKLpZXS1kPKPYYP",
	"header": "header--9gRrBKt5FtN4oYBM-cc8P",
	"search_btn": "search_btn--kCuC388Mx_Hg-z0gldOW3",
	"table_footer": "table_footer--2eslvltnNXFktxqTBd6I5D",
	"total_num": "total_num--2Mgc9O_EhblXhWlLeHuhf_",
	"pager": "pager--JZFtfaCzZuy0BugCbPw3o",
	"confirm": "confirm--2Ps6XqG-esm1c5DkGXYKjc"
};